import { SOURCE_KEY } from '../constants'


/**
 * @props {Object} message
 * @props {String} message.masterOrigin
 * @props {String} message.origin
 * @props {Object} message.payload
 * @props {Object} message.payload.consents
 * @props {Number} message.payload.createdAt
 * @props {String} message.source
 *
 * @returns {Boolean}
 */
export default function validateMessage({ masterOrigin, origin, payload, source }) {
  if ( source !== SOURCE_KEY ) {
    return false
  }

  if ( origin !== masterOrigin ) {
    console.debug('Ignoring message: origin (%o) does not match master origin (%o)',
                  origin,
                  masterOrigin)
    return false
  }

  if ( !payload ) {
    return false
  }

  return Boolean(payload?.consents?.id)
}
